import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from './Icon.js';
// Each icon is hand-drawn on a 24x24 grid to match the Slingu tone:
// rounded strokes, slightly geometric, friendly.
export function HomeIcon(p) {
    return (_jsx(Icon, { ...p, children: _jsx("path", { d: "M3 11.5 12 4l9 7.5V19a2 2 0 0 1-2 2h-4v-6h-6v6H5a2 2 0 0 1-2-2v-7.5Z" }) }));
}
export function TargetIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("circle", { cx: "12", cy: "12", r: "9" }), _jsx("circle", { cx: "12", cy: "12", r: "5" }), _jsx("circle", { cx: "12", cy: "12", r: "1.5", fill: "currentColor" })] }));
}
export function TrophyIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M8 4h8v5a4 4 0 0 1-8 0V4Z" }), _jsx("path", { d: "M4 5h4v3a3 3 0 0 1-3-3V5ZM16 5h4v0a3 3 0 0 1-3 3V5Z" }), _jsx("path", { d: "M10 13h4v3h-4z" }), _jsx("path", { d: "M8 20h8M12 16v4" })] }));
}
export function UserIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("circle", { cx: "12", cy: "8", r: "4" }), _jsx("path", { d: "M4 21c0-4 4-6 8-6s8 2 8 6" })] }));
}
export function FlameIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M12 3c.5 3 3 4 3 7a3 3 0 0 1-6 0c0-1 .5-1.5 1-2" }), _jsx("path", { d: "M7 13c0-1 .5-2 1.5-3 .5 3 3.5 3 3.5 6a3.5 3.5 0 1 1-7 0c0-1.5.8-2.5 2-3Z" })] }));
}
export function HeartIcon(p) {
    return (_jsx(Icon, { ...p, children: _jsx("path", { d: "M12 20s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 10c0 5.65-7 10-7 10Z" }) }));
}
export function GemIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M6 9h12l-6 12L6 9Z" }), _jsx("path", { d: "M4 9l2-5h12l2 5" }), _jsx("path", { d: "M4 9h16M9 4l3 5 3-5" })] }));
}
export function StarIcon(p) {
    return (_jsx(Icon, { ...p, children: _jsx("path", { d: "m12 3 2.9 5.9 6.6.9-4.7 4.6 1 6.6L12 18l-5.8 3 1-6.6L2.5 9.8l6.6-.9L12 3Z" }) }));
}
export function CheckIcon(p) {
    return (_jsx(Icon, { ...p, strokeWidth: 3, children: _jsx("path", { d: "M5 12.5 10 17l9-10" }) }));
}
export function CloseIcon(p) {
    return (_jsx(Icon, { ...p, strokeWidth: 3, children: _jsx("path", { d: "M6 6l12 12M18 6 6 18" }) }));
}
export function LockIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("rect", { x: "5", y: "11", width: "14", height: "9", rx: "2" }), _jsx("path", { d: "M8 11V8a4 4 0 0 1 8 0v3" })] }));
}
export function PlayIcon(p) {
    return (_jsx(Icon, { ...p, children: _jsx("path", { d: "M7 5v14l12-7L7 5Z", fill: "currentColor", stroke: "none" }) }));
}
export function GamepadIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M6 9h12a4 4 0 0 1 4 4v1a4 4 0 0 1-7 2.7L13.5 15h-3l-1.5 1.7A4 4 0 0 1 2 14v-1a4 4 0 0 1 4-4Z" }), _jsx("path", { d: "M8 12v3M6.5 13.5h3", strokeLinecap: "round" }), _jsx("circle", { cx: "15.5", cy: "12.5", r: "1", fill: "currentColor", stroke: "none" }), _jsx("circle", { cx: "17.5", cy: "14.5", r: "1", fill: "currentColor", stroke: "none" })] }));
}
export function XpBoltIcon(p) {
    return (_jsx(Icon, { ...p, children: _jsx("path", { d: "M13 3 4 14h6l-1 7 9-11h-6l1-7Z", fill: "currentColor", stroke: "none" }) }));
}
export function SparkleIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M12 3v4M12 17v4M3 12h4M17 12h4" }), _jsx("path", { d: "m5.6 5.6 2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" })] }));
}
export function ShopIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M4 7h16l-1 12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4 7Z" }), _jsx("path", { d: "M8 7V5a4 4 0 0 1 8 0v2" })] }));
}
export function BookIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M5 4h10a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3V4Z" }), _jsx("path", { d: "M5 4v13a3 3 0 0 0 3 3h10" })] }));
}
export function ChevronRightIcon(p) {
    return (_jsx(Icon, { ...p, children: _jsx("path", { d: "M9 6l6 6-6 6" }) }));
}
export function MicIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("rect", { x: "9", y: "3", width: "6", height: "12", rx: "3" }), _jsx("path", { d: "M5 11a7 7 0 0 0 14 0M12 18v3M9 21h6" })] }));
}
export function HeadphonesIcon(p) {
    return (_jsxs(Icon, { ...p, children: [_jsx("path", { d: "M4 14a8 8 0 0 1 16 0" }), _jsx("rect", { x: "3", y: "14", width: "4", height: "6", rx: "1.5" }), _jsx("rect", { x: "17", y: "14", width: "4", height: "6", rx: "1.5" })] }));
}
//# sourceMappingURL=index.js.map